var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSlackDefault(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.525 12.5932C21.525 13.9648 20.4093 15.0806 19.0378 15.0806C17.6664 15.0806 16.5506 13.9648 16.5506 12.5933V6.48723C16.5506 5.11576 17.6664 4 19.0378 4C20.4093 4 21.525 5.11576 21.525 6.48723V12.5932Z",
    fill: "#999999"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.5123 15.0805H23.7282C23.3399 15.0805 23.0251 14.7657 23.0251 14.3774V12.5932C23.0251 11.2218 24.1409 10.106 25.5123 10.106C26.8838 10.106 27.9995 11.2218 27.9995 12.5932C27.9995 13.9647 26.8838 15.0805 25.5123 15.0805Z",
    fill: "#999999"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.48719 15.449H12.5931C13.9646 15.449 15.0803 14.3332 15.0803 12.9616C15.0803 11.5902 13.9646 10.4745 12.5931 10.4745H6.48719C5.11575 10.4745 4 11.5903 4 12.9617C4 14.3332 5.11575 15.449 6.48719 15.449Z",
    fill: "#999999"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.3766 8.97445H12.5926C11.2211 8.97445 10.1054 7.85869 10.1054 6.48723C10.1054 5.11576 11.2211 4 12.5926 4C13.964 4 15.0797 5.11576 15.0797 6.48723V8.27133C15.0797 8.65964 14.7649 8.97445 14.3766 8.97445Z",
    fill: "#999999"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9617 16.9194C11.5902 16.9194 10.4745 18.0352 10.4745 19.4067V25.5127C10.4745 26.8842 11.5902 28 12.9617 28C14.3332 28 15.449 26.8842 15.449 25.5127V19.4067C15.449 18.0352 14.3332 16.9194 12.9617 16.9194Z",
    fill: "#999999"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M6.48719 16.9194H8.27132C8.65962 16.9194 8.97443 17.2342 8.97448 17.6225V19.4067C8.97448 20.7782 7.85868 21.8939 6.48719 21.8939C5.11575 21.8939 4 20.7782 4 19.4067C4 18.0352 5.11575 16.9194 6.48719 16.9194Z",
    fill: "#999999"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M25.5128 16.5509H19.4069C18.0354 16.5509 16.9197 17.6667 16.9197 19.0382C16.9197 20.4097 18.0354 21.5254 19.4069 21.5254H25.5128C26.8843 21.5254 28 20.4097 28 19.0382C28 17.6667 26.8842 16.5509 25.5128 16.5509Z",
    fill: "#999999"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M17.6228 23.0254H19.4069C20.7784 23.0254 21.8941 24.1412 21.8942 25.5127C21.8942 26.8842 20.7784 28 19.4069 28C18.0354 28 16.9197 26.8842 16.9197 25.5127V23.7285C16.9197 23.3402 17.2345 23.0254 17.6228 23.0254Z",
    fill: "#999999"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSlackDefault);
export default __webpack_public_path__ + "static/media/slackDefault.d8467e154f537c25903e98315abbde4e.svg";
export { ForwardRef as ReactComponent };